import * as React from 'react'
import {ReactElement} from 'react'
import styled from 'styled-components'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import { Table, TableRow, TableBody, TableCell, Box } from '@mui/material';
import {Colors} from '../../../../styledComponents/Constants'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'

interface Props {
    rejectionReason: string
    eventEmitter: EventEmitterExAdmin
    onChange: (value: string) => void
}

interface State {
    rejectionReason: string
}

export default class NatAuthKeyNoticeApplyRejectionForm extends React.Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            rejectionReason: this.props.rejectionReason,
        }
        this.handleRejectionReasonChange = this.handleRejectionReasonChange.bind(this)
    }

    handleRejectionReasonChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
                rejectionReason: event.target.value,
            }, () => {
                this.props.onChange(this.state.rejectionReason)
            }
        )
    }

    render(): ReactElement {
        return (
            <FormBox>
                <Table>
                    <TableBody>
                        <TableRow>
                            <RowNameCell>却下理由</RowNameCell>
                            <InputCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                            placeholder: '申請の却下理由',
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.rejectionReason}
                                    eventKeys={['rejectionReason']}
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.handleRejectionReasonChange}
                                />
                            </InputCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </FormBox>
        )
    }
}

const FormBox = styled(Box)`
  border: solid 2px ${Colors.Shadow};
  margin: 5px;
  padding: 10px;
`
const RowNameCell = styled(TableCell)`
 &.MuiTableCell-root {
  border-bottom: none;
  font-size: 1rem;
  line-height: 2.3em;
  vertical-align: top;
  white-space: nowrap;
  padding: 2px 12px 2px 12px;
  }
`
const InputCell = styled(TableCell)`
 &.MuiTableCell-root {
  border-bottom: none;
  line-height: 2.5em;
  padding: 2px 12px 2px 12px;
  white-space: nowrap;
  width: 100%;
  }
`